import axios from 'axios';
import { create } from 'zustand';
import { API_BASE_URL } from '../../api/config';

// The platform panel talks to /api/platform/* with its OWN token — no
// tenant slug, no tenant refresh cookie. Token is memory-only (12h JWT);
// a hard reload sends staff back to the platform login, which is fine
// for an internal control panel.

export interface PlatformUser {
  platformUserId: string;
  email: string;
  fullNameAr: string;
  fullNameEn: string | null;
  role: number; // 1 SuperAdmin, 2 SubAdmin
  isActive: boolean;
  lastLoginAt: string | null;
}

interface PlatformAuthState {
  token: string | null;
  user: PlatformUser | null;
  setSession: (token: string, user: PlatformUser) => void;
  clear: () => void;
}

export const usePlatformAuthStore = create<PlatformAuthState>((set) => ({
  token: null,
  user: null,
  setSession: (token, user) => set({ token, user }),
  clear: () => set({ token: null, user: null }),
}));

export const platformApi = axios.create({ baseURL: API_BASE_URL });

platformApi.interceptors.request.use((config) => {
  const token = usePlatformAuthStore.getState().token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

platformApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      usePlatformAuthStore.getState().clear();
    }
    return Promise.reject(error);
  },
);
